import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarchiUplodadComponent } from './marchi-uplodad/marchi-uplodad.component';



@NgModule({
  declarations: [MarchiUplodadComponent],
  imports: [
    CommonModule
  ],
  exports: [MarchiUplodadComponent]
})
export class MarchiSharedModule { }
